// Five-box Leitner system — simple, transparent, robust.
//
// Box 1: due today              (just learning or just failed)
// Box 2: due in 1 day
// Box 3: due in 3 days
// Box 4: due in 7 days
// Box 5: due in 14 days         (effectively mastered)
//
// Each card responds to one of three ratings:
//   "again" → reset to box 1
//   "good"  → +1 box
//   "easy"  → +2 boxes (skip ahead)

import { loadState, saveState } from './storage.js';

const INTERVALS_DAYS = { 1: 0, 2: 1, 3: 3, 4: 7, 5: 14 };

function nowIso() {
  return new Date().toISOString();
}

function dueAfterDays(days) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + days);
  return d.toISOString();
}

function freshCard() {
  return { box: 1, due: nowIso(), seen: 0, correct: 0 };
}

export function getCard(id) {
  const state = loadState();
  return state.cards[id] || freshCard();
}

export function rateCard(id, rating) {
  const state = loadState();
  const card = state.cards[id] || freshCard();
  card.seen += 1;

  if (rating === 'again') {
    card.box = 1;
  } else if (rating === 'good') {
    card.box = Math.min(5, card.box + 1);
    card.correct += 1;
  } else if (rating === 'easy') {
    card.box = Math.min(5, card.box + 2);
    card.correct += 1;
  }

  if (card.box >= 5 && !state.mastered.includes(id)) {
    state.mastered.push(id);
  }
  if (card.box < 5) {
    state.mastered = state.mastered.filter(x => x !== id);
  }

  card.due = dueAfterDays(INTERVALS_DAYS[card.box] ?? 14);
  state.cards[id] = card;
  saveState(state);
  return card;
}

export function dueCards(vocab) {
  const state = loadState();
  const today = nowIso();
  return vocab.filter(v => {
    const c = state.cards[v.id];
    if (!c) return true; // never seen → always due
    return c.due <= today;
  });
}

export function stats(vocab) {
  const state = loadState();
  const total = vocab.length;
  const seen = vocab.filter(v => state.cards[v.id]).length;
  const mastered = vocab.filter(v => (state.cards[v.id]?.box ?? 0) >= 5).length;
  const learning = seen - mastered;
  const fresh = total - seen;
  return { total, seen, mastered, learning, fresh };
}
